import type {
  PixabayImage,
  PixabaySearchInput,
} from '@travel-planner/uploadthing/pixabay';
import type { UploadedFile } from '@travel-planner/uploadthing/types';
import { useMemo } from 'react';
import { trpc } from '@/shared/api/trpc';

// Hook that returns the consumer-side callbacks the package's <AddedImages>
// + <PixabaySearchPanel> expect. Wires them to the uploadthing tRPC router
// so any feature that mounts these components shares the same plumbing.
export const useUploadthingActions = () => {
  const utils = trpc.useUtils();
  const deleteFiles = trpc.uploadthing.deleteFiles.useMutation();
  const uploadFromUrl = trpc.uploadthing.uploadFromUrl.useMutation();

  return useMemo(() => {
    const onDeleteKey = (key: string) => {
      deleteFiles.mutate({ keys: [key] });
    };

    const searchPixabay = async (
      input: PixabaySearchInput
    ): Promise<PixabayImage[]> => {
      const result = await utils.uploadthing.pixabaySearch.fetch(input);
      return result.hits;
    };

    const uploadPixabayUrls = async (
      urls: string[]
    ): Promise<UploadedFile[]> => {
      return uploadFromUrl.mutateAsync({ urls });
    };

    return {
      onDeleteKey,
      pixabay: {
        search: searchPixabay,
        uploadFromUrl: uploadPixabayUrls,
      },
    };
  }, []);
};
